import React, {useEffect, useRef, useState} from 'react';
import { config } from '@fortawesome/fontawesome-svg-core';

import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

import {
  faCheck as fasCheck,
  faInfo as fasInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {Tooltip} from "@mui/material";
import Checkers from "../../../../../helpers/class/Checkers";

export default function FeatureDescription ( props ) {

  const has_description = props.description != null && props.description != '';
  const has_extra_description = props.extra_description != null && props.extra_description != '';

  return (
    <>
      {
        <span>
          {
            props.hasOwnProperty( 'icon_info' ) &&
              <FontAwesomeIcon icon={fasCheck} className="text-master m-r-10" size="1x"/>
          }
          {
            has_description ?
                <>
                  {props.description}
                </>
                :
                <></>
          }
          <span>
            {props.title}
            {
              props.hasOwnProperty( 'value' ) ?
                <>
                                    : <strong>{props.value}</strong>
                </>
                :props.hasOwnProperty( 'options' ) &&
                  Checkers.isValidArray(props.options) && props.options.map( ( option ) => {
                    return (
                      <>
                              : <strong key={option.option_id.toString()}>{option.option_value}</strong>
                      </>
                    )
                  })
            }
          </span>
        </span>

      }
      {
        props.hasOwnProperty( 'icon_info' ) &&
          has_extra_description ?
            <>
              {
                <Tooltip placement={'top'}
                         title={props.extra_description}
                         componentsProps={{
                           tooltip: {
                             sx: {
                               backgroundColor: '#000',
                               color: "#ffffff",
                               boxShadow: "0px 0px 2px #000",
                               zIndex: "999999999999 !important"
                             },
                           },
                         }}
                >
                    <span>
                      &nbsp;<FontAwesomeIcon icon={fasInfo} className="text-master" size="1x"/>
                    </span>
                </Tooltip>
              }
            </>
            :
            <></>
      }
    </>
  );
}
